import { navigationContextInitialState } from './navigation.constants';
import { NavigationContextType } from './navigation.types';

import { createTypeSafeContext } from '~/core/utils';

const [useNavigationContext, NavigationContext] =
  createTypeSafeContext<NavigationContextType>(navigationContextInitialState);

export { NavigationContext, useNavigationContext };
